// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GenericVizAxisTab-module__dsAccented--lQ5at,.GenericVizAxisTab-module__dsAccented--lQ5at *{font-weight:500}.GenericVizAxisTab-module__dsDefaultWeight--YZurz,.GenericVizAxisTab-module__dsDefaultWeight--YZurz *{font-weight:400}h5.GenericVizAxisTab-module__dsAccented--lQ5at,h5.GenericVizAxisTab-module__dsAccented--lQ5at *{font-weight:700}.GenericVizAxisTab-module__dsUnderline--CpAMd,.GenericVizAxisTab-module__dsUnderline--CpAMd *{text-decoration:underline}.GenericVizAxisTab-module__dsAccented2--Ww1xb,.GenericVizAxisTab-module__dsAccented2--Ww1xb *{font-weight:700}.GenericVizAxisTab-module__dsBodyXL--g8U5n,.GenericVizAxisTab-module__dsBodyXL--g8U5n *{font-size:18px;line-height:27px}.GenericVizAxisTab-module__dsBodyLarge--RCzr8,.GenericVizAxisTab-module__dsBodyLarge--RCzr8 *{font-size:16px;line-height:24px}.GenericVizAxisTab-module__dsBody--H7SRH,.GenericVizAxisTab-module__dsBody--H7SRH *{font-size:14px;line-height:20px}.GenericVizAxisTab-module__dsBodySmall--JmgPW,.GenericVizAxisTab-module__dsBodySmall--JmgPW *{font-size:12px;line-height:18px}.GenericVizAxisTab-module__dsBodyXS--WxtQD,.GenericVizAxisTab-module__dsBodyXS--WxtQD *{font-size:10px;line-height:15px}.GenericVizAxisTab-module__dsActionLarge--gzXNY,.GenericVizAxisTab-module__dsActionLarge--gzXNY *{font-size:16px;line-height:18px}.GenericVizAxisTab-module__dsAction--zD7kc,.GenericVizAxisTab-module__dsAction--zD7kc *{font-size:14px;line-height:16px}.GenericVizAxisTab-module__dsActionSmall--RHPgW,.GenericVizAxisTab-module__dsActionSmall--RHPgW *{font-size:12px;line-height:14px}.GenericVizAxisTab-module__dsColumnHeadLine--WF3yA,.GenericVizAxisTab-module__dsColumnHeadLine--WF3yA *{font-size:12px;line-height:18px;font-weight:500;text-transform:uppercase}.GenericVizAxisTab-module__dsLightXL--tlFa6,.GenericVizAxisTab-module__dsLightXL--tlFa6 *{font-size:120px;line-height:160px;font-weight:300}.GenericVizAxisTab-module__dsLightLarge--fSujL,.GenericVizAxisTab-module__dsLightLarge--fSujL *{font-size:48px;line-height:64px;font-weight:300}.GenericVizAxisTab-module__dsLight--TOrgk,.GenericVizAxisTab-module__dsLight--TOrgk *{font-size:32px;line-height:64px;font-weight:300}.GenericVizAxisTab-module__dsLightSmall--nCupj,.GenericVizAxisTab-module__dsLightSmall--nCupj *{font-size:24px;line-height:36px;font-weight:300}.GenericVizAxisTab-module__dsLightXS--Cvapl,.GenericVizAxisTab-module__dsLightXS--Cvapl *{font-size:18px;line-height:27px;font-weight:300}.GenericVizAxisTab-module__container--iVTIk .GenericVizAxisTab-module__axisTitle--yOBPS{font-size:12px;font-weight:500;line-height:18px;color:#8c95a8;margin-bottom:20px}.GenericVizAxisTab-module__container--iVTIk .GenericVizAxisTab-module__label--JQ6ET{margin:0;font-size:14px;line-height:20px;font-weight:500;color:#5f677e}.GenericVizAxisTab-module__container--iVTIk .GenericVizAxisTab-module__label--JQ6ET .GenericVizAxisTab-module__input--346XI{margin-bottom:8px}.GenericVizAxisTab-module__container--iVTIk .GenericVizAxisTab-module__titleContainer--gKl3s{margin:20px 0 32px}.GenericVizAxisTab-module__container--iVTIk .GenericVizAxisTab-module__titleContainer--gKl3s .GenericVizAxisTab-module__label--JQ6ET{margin-bottom:8px}.GenericVizAxisTab-module__container--iVTIk .GenericVizAxisTab-module__toggleContainer--WJim1{height:21px;display:flex;align-items:center;gap:8px}.GenericVizAxisTab-module__container--iVTIk .GenericVizAxisTab-module__toggleContainer--WJim1.showXAxisTickLabels,.GenericVizAxisTab-module__container--iVTIk .GenericVizAxisTab-module__toggleContainer--WJim1.showYAxisTickLabels{margin-top:20px}.GenericVizAxisTab-module__container--iVTIk .GenericVizAxisTab-module__toggleContainer--WJim1 label{cursor:pointer}.GenericVizAxisTab-module__container--iVTIk .GenericVizAxisTab-module__customRangeContainer--E6EZG{margin-top:20px;margin-bottom:40px}.GenericVizAxisTab-module__container--iVTIk .GenericVizAxisTab-module__customRangeContainer--E6EZG .GenericVizAxisTab-module__label--JQ6ET{margin-bottom:8px}.GenericVizAxisTab-module__container--iVTIk .GenericVizAxisTab-module__customRangeContainer--E6EZG .GenericVizAxisTab-module__customRange--Ly84O{display:flex;gap:8px}.GenericVizAxisTab-module__container--iVTIk .GenericVizAxisTab-module__customRangeContainer--E6EZG .GenericVizAxisTab-module__customRange--Ly84O .GenericVizAxisTab-module__inputWrapper--RfvUJ{width:125px}.GenericVizAxisTab-module__container--iVTIk .GenericVizAxisTab-module__customRangeContainer--E6EZG .GenericVizAxisTab-module__customRange--Ly84O .GenericVizAxisTab-module__inputWrapper--RfvUJ label{margin:0;font-size:12px;line-height:18px;font-weight:500;color:#b3b9c8}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dsPrimaryBlue": `#5155f5`,
	"dsSecondaryBlue": `#e5e5fe`,
	"dsHoverBlue": `#3438d0`,
	"dsClickBlue": `#262ab5`,
	"dsClickBlue2": `#d3d4f0`,
	"dsClickBlue3": `#a8a9e1`,
	"dsClickBlue4": `#7c7fd2`,
	"dsClickBlue5": `#5154c3`,
	"dsBlack": `#191a1c`,
	"dsGray1": `#f5f7fa`,
	"dsGray2": `#eaecf2`,
	"dsGray3": `#dce0ea`,
	"dsGray4": `#b3b9c8`,
	"dsGray5": `#8c95a8`,
	"dsGray6": `#5f677e`,
	"dsGray7": `#3d4355`,
	"dsGrayMainHeader": `#373d4d`,
	"dsGrayLine": `#e2e2e2`,
	"dsGrayBackground": `#f4f4f5`,
	"dsWhite": `#fff`,
	"dsWarning": `#f14668`,
	"dsSuccess": `#00d41f`,
	"dsActionYellow": `#f3b32a`,
	"dsActionYellowLight": `#fef7e7`,
	"dsChartGreen": `#19a979`,
	"dsChartPink": `#ed4a7b`,
	"dsChartYellow": `#f4b400`,
	"dsChartPurple": `#945fcf`,
	"dsChartTurquoise": `#12a4b4`,
	"dsChartBlue": `#525df4`,
	"dsChartOrange": `#fb9341`,
	"dsChartBurgundy": `#bf399e`,
	"dsChartRed": `#ef6868`,
	"dsChartGrey": `#6c8893`,
	"dsChartDarkBlue": `#2e6497`,
	"dsChartOrangeLight": `#feddc3`,
	"dsChartLightBlue": `#5899da`,
	"dsTeamProRed": `#ff594c`,
	"dsFreeYellow": `#ffb42e`,
	"dsTeamsGreen": `#52aea4`,
	"dsTableRowHover": `#f7f8fa`,
	"dsTableNegativeHighlight": `#ffeae9`,
	"dsTableNegativeHighlightHover": `#ffe0df`,
	"dsSparklinePurple": `#777af7`,
	"dsPrimaryBlue100": `#f3f4fe`,
	"dsPrimaryBlue200": `#cfd0ff`,
	"dsPrimaryBlue300": `#8889f8`,
	"dsPrimaryBlue400": `#6c6ff7`,
	"dsPrimaryBlue500": `#575af5`,
	"dsPrimaryBlue600": `#4449f3`,
	"dsPrimaryBlue700": `#3339f1`,
	"dsPrimaryBlue800": `#1f29ef`,
	"dsPrimaryBlue900": `#1823de`,
	"dsPrimaryBlue1000": `#151fcc`,
	"dsMainHeader100": `#f9f9fa`,
	"dsMainHeader200": `#b5b7bc`,
	"dsMainHeader300": `#91959d`,
	"dsMainHeader400": `#7b7f89`,
	"dsMainHeader500": `#6b6f7b`,
	"dsMainHeader600": `#5e6370`,
	"dsMainHeader700": `#545967`,
	"dsMainHeader800": `#4b505f`,
	"dsMainHeader900": `#434958`,
	"dsMainHeader1000": `#3d4252`,
	"dsWarning100": `#fcdce3`,
	"dsWarning200": `#f9b5c2`,
	"dsWarning300": `#f46d88`,
	"dsWarning400": `#e44262`,
	"dsWarning500": `#c83a56`,
	"dsWarning600": `#b2344d`,
	"dsWarning700": `#a02f45`,
	"dsWarning800": `#922a3f`,
	"dsWarning900": `#852639`,
	"dsWarning1000": `#792334`,
	"dsH1FontSize": `32px`,
	"dsH1LineHeight": `48px`,
	"dsH2FontSize": `26px`,
	"dsH2LineHeight": `39px`,
	"dsH3FontSize": `22px`,
	"dsH3LineHeight": `33px`,
	"dsH4FontSize": `18px`,
	"dsH4LineHeight": `27px`,
	"dsH5FontSize": `16px`,
	"dsH5LineHeight": `24px`,
	"dsH6FontSize": `14px`,
	"dsH6LineHeight": `20px`,
	"dsBodyXLFontSize": `18px`,
	"dsBodyXLLineHeight": `27px`,
	"dsBodyLargeFontSize": `16px`,
	"dsBodyLargeLineHeight": `24px`,
	"dsBodyFontSize": `14px`,
	"dsBodyLineHeight": `20px`,
	"dsBodySmallFontSize": `12px`,
	"dsBodySmallLineHeight": `18px`,
	"dsBodyXSFontSize": `10px`,
	"dsBodyXSLineHeight": `15px`,
	"dsActionLargeSize": `16px`,
	"dsActionLargeLineHeight": `18px`,
	"dsActionSize": `14px`,
	"dsActionLineHeight": `16px`,
	"dsActionSmallSize": `12px`,
	"dsActionSmallLineHeight": `14px`,
	"dsColumnHeadFontSize": `12px`,
	"dsColumnHeadLineHeight": `18px`,
	"dsLightXLFontSize": `120px`,
	"dsLightXLLineHeight": `160px`,
	"dsLightLargeFontSize": `48px`,
	"dsLightLargeLineHeight": `64px`,
	"dsLightFontSize": `32px`,
	"dsLightLineHeight": `64px`,
	"dsLightSmallFontSize": `24px`,
	"dsLightSmallLineHeight": `36px`,
	"dsLightXSFontSize": `18px`,
	"dsLightXSLineHeight": `27px`,
	"dsXsIconSize": `12px`,
	"dsSmallIconSize": `14px`,
	"dsMediumIconSize": `16px`,
	"dsMediumFieldHeight": `36px`,
	"dsSmallFieldHeight": `32px`,
	"dsLargeFieldHeight": `40px`,
	"dsFieldHorizontalPadding": `12px`,
	"dsAccented": `GenericVizAxisTab-module__dsAccented--lQ5at`,
	"dsDefaultWeight": `GenericVizAxisTab-module__dsDefaultWeight--YZurz`,
	"dsUnderline": `GenericVizAxisTab-module__dsUnderline--CpAMd`,
	"dsAccented2": `GenericVizAxisTab-module__dsAccented2--Ww1xb`,
	"dsBodyXL": `GenericVizAxisTab-module__dsBodyXL--g8U5n`,
	"dsBodyLarge": `GenericVizAxisTab-module__dsBodyLarge--RCzr8`,
	"dsBody": `GenericVizAxisTab-module__dsBody--H7SRH`,
	"dsBodySmall": `GenericVizAxisTab-module__dsBodySmall--JmgPW`,
	"dsBodyXS": `GenericVizAxisTab-module__dsBodyXS--WxtQD`,
	"dsActionLarge": `GenericVizAxisTab-module__dsActionLarge--gzXNY`,
	"dsAction": `GenericVizAxisTab-module__dsAction--zD7kc`,
	"dsActionSmall": `GenericVizAxisTab-module__dsActionSmall--RHPgW`,
	"dsColumnHeadLine": `GenericVizAxisTab-module__dsColumnHeadLine--WF3yA`,
	"dsLightXL": `GenericVizAxisTab-module__dsLightXL--tlFa6`,
	"dsLightLarge": `GenericVizAxisTab-module__dsLightLarge--fSujL`,
	"dsLight": `GenericVizAxisTab-module__dsLight--TOrgk`,
	"dsLightSmall": `GenericVizAxisTab-module__dsLightSmall--nCupj`,
	"dsLightXS": `GenericVizAxisTab-module__dsLightXS--Cvapl`,
	"container": `GenericVizAxisTab-module__container--iVTIk`,
	"axisTitle": `GenericVizAxisTab-module__axisTitle--yOBPS`,
	"label": `GenericVizAxisTab-module__label--JQ6ET`,
	"input": `GenericVizAxisTab-module__input--346XI`,
	"titleContainer": `GenericVizAxisTab-module__titleContainer--gKl3s`,
	"toggleContainer": `GenericVizAxisTab-module__toggleContainer--WJim1`,
	"customRangeContainer": `GenericVizAxisTab-module__customRangeContainer--E6EZG`,
	"customRange": `GenericVizAxisTab-module__customRange--Ly84O`,
	"inputWrapper": `GenericVizAxisTab-module__inputWrapper--RfvUJ`
};
module.exports = ___CSS_LOADER_EXPORT___;
